<template>
    <div class="megamenu" v-if="isVisible">
        <div class="megamenu-container">
            <MegaMenuItem v-for="(item, key) in items"
                      :key="key"
                      :data="item"
                      :all-text="allText"
            />
        </div>
    </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue'

import MegaMenuItem from './MegaMenuItem';

export default {

    props: [
        'open',
        'items',
        'allText'
    ],

    components: {
        MegaMenuItem
    },

    setup(props) {

        const isVisible = ref(false)

        onMounted( () => {
            if (  window.innerWidth > 991 )
                isVisible.value = true
            else
                isVisible.value = props.open
        })

        watch( () => props.open, (value, oldValue) => {
            isVisible.value = value
        })

        return {
            isVisible
        }
    }
}
</script>
